import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import React from 'react';
import useScreenSize from '../../../util/hooks/useScreenSize';

const SectionImagesLoadingSkeleton = () => {
  const { isMobile, isTablet } = useScreenSize();

  if (isMobile || isTablet) {
    return (<Box
      sx={{
        height: '300px',
      }}
    >
      <Box
        sx={{
          height: '100%', borderRadius: '16px', overflow: 'hidden',
        }}
      >
        <Grid
          columnSpacing={1}
          container
          sx={{
            height: '100%',
          }}
        >
          <Grid size={{ md: 8, xs: 12 }}>
            <Skeleton height="100%" variant="rectangular" width="100%" />
          </Grid>
        </Grid>
      </Box>
    </Box>);
  }

  return (<Box
    sx={{
      mt: 10, height: '596px',
    }}
  >
    <Container
      maxWidth="xl"
      sx={{
        height: '100%',
      }}
    >
      <Box
        sx={{
          height: '100%', borderRadius: '16px', overflow: 'hidden',
        }}
      >
        <Grid
          columnSpacing={1}
          container
          sx={{
            height: '100%',
          }}
        >
          <Grid size={{ md: 8, xs: 12 }}>
            <Skeleton height="100%" variant="rectangular" width="100%" />
          </Grid>
          <Grid container rowSpacing={1} size={{ md: 4, xs: 12 }}>
            <Grid size={12}>
              <Skeleton height="100%" variant="rectangular" width="100%" />
            </Grid>
            <Grid size={12}>
              <Skeleton height="100%" variant="rectangular" width="100%" />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </Container>
  </Box>);
};

export default SectionImagesLoadingSkeleton;